import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'coaching-tracker',
    path: '/leadership-capabilities',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'coaching-tracker',
      breadcrumb: {
        label: 'core.menu.modules.leadership-capabilities',
        route: 'coaching-tracker',
      },
    },
    children: [
      {
        name: 'coaching-tracker-home',
        path: '/leadership-capabilities/coaching-tracker',
        meta: {
          allowedRoles: [...allowed.coaching_tracker.roles],
          breadcrumb: {
            label: 'core.menu.modules.coaching-tracker',
            route: 'coaching-tracker-home',
          },
        },
        component: () =>
          import(
            '@/modules/coaching-tracker/pages/home/coaching-tracker-home.vue'
          ),
      },
      {
        name: 'coaching-tracker-create-project',
        path: '/leadership-capabilities/coaching-tracker/create/:id?',
        meta: {
          allowedRoles: [...allowed.coaching_tracker.roles],
          breadcrumb: {
            label: 'coaching-tracker.createProject',
            route: 'coaching-tracker-create-project',
          },
        },
        component: () =>
          import(
            '@/modules/coaching-tracker/pages/create-project/create-project.vue'
          ),
      },
      {
        name: 'coaching-tracker-project-report',
        path: '/leadership-capabilities/coaching-tracker/project/:id/report',
        meta: {
          allowedRoles: [...allowed.coaching_tracker.roles],
          breadcrumb: {
            label: 'coaching-tracker.projectReport',
            route: 'coaching-tracker-project-report',
          },
        },
        component: () =>
          import(
            '@/modules/coaching-tracker/pages/project-report/project-report.vue'
          ),
      },
      {
        name: 'coaching-tracker-project-details',
        path: '/leadership-capabilities/coaching-tracker/project/:id',
        meta: {
          allowedRoles: [...allowed.coaching_tracker.roles],
          breadcrumb: {
            label: 'coaching-tracker.projectDetails',
            route: 'coaching-tracker-project-details',
          },
        },
        component: () =>
          import(
            '@/modules/coaching-tracker/pages/project-details/project-details.vue'
          ),
      },
    ],
  },
]

export default routes
